import Heading from '../../components/atoms/Heading'
import Layout from '../../templates/Layout'
import PendingInvoicesTable from '../../templates/InvoicesTable'

const PaidInvoicesPage = () => {
  return (
    <Layout>
      <Heading type="1" border margin>
        Facturas Cobradas
      </Heading>
      <PendingInvoicesTable status="paid" />
    </Layout>
  )
}

export default PaidInvoicesPage
